(() => {
  const init = (box) => {
    if (box.dataset.initialized === 'true') return;
    box.dataset.initialized = 'true';
    let variants, optionNames;
    try {
      variants = JSON.parse(box.dataset.variants || '[]');
      optionNames = JSON.parse(box.dataset.options || '[]');
    } catch { box.hidden = true; return; }
    const root = box.closest('product-info');
    const message = box.querySelector('[data-fashion-stock-message]');
    if (!root || !message || !variants.length) { box.hidden = true; return; }
    const threshold = Number(box.dataset.threshold) || 4;
    const demoMode = box.dataset.demo === 'true';
    const demoStockFor = (variant) => {
      const key = 'fashionStockPreviewV2:' + variant.id;
      try {
        const saved = sessionStorage.getItem(key);
        if (saved) return JSON.parse(saved);
        const value = { state: 'low', quantity: 1 + Math.floor(Math.random() * threshold) };
        sessionStorage.setItem(key, JSON.stringify(value));
        return value;
      } catch {
        return { state: 'low', quantity: 1 + Math.floor(Math.random() * threshold) };
      }
    };
    const render = () => {
      const selected = [];
      const picker = root.querySelector('variant-selects, variant-radios');
      if (picker) {
        picker.querySelectorAll('.product-form__input').forEach((group) => {
          const checked = group.querySelector('input[type="radio"]:checked');
          const select = group.querySelector('select');
          const value = checked?.value ?? select?.value;
          if (value != null) selected.push(value);
        });
      }
      const variant = variants.find((item) => item.options.length === selected.length && item.options.every((value, index) => value === selected[index]));
      if (!variant) { box.hidden = true; return; }
      const sizeIndex = optionNames.findIndex((name) => /size|maat/i.test(name));
      const colorIndex = optionNames.findIndex((name) => /colou?r/i.test(name));
      const size = sizeIndex >= 0 && variant.options[sizeIndex] ? ' in size ' + variant.options[sizeIndex] : '';
      const color = colorIndex >= 0 && variant.options[colorIndex] ? ' · ' + variant.options[colorIndex] : '';
      const demoStock = demoMode && variant.available ? demoStockFor(variant) : null;
      let nextMessage;
      let nextState;
      if (demoStock?.state === 'available') {
        nextMessage = 'In Stock';
        nextState = 'available';
      } else if (demoStock?.state === 'low') {
        nextMessage = 'Only ' + demoStock.quantity + ' left' + size + color;
        nextState = 'low';
      } else if (!variant.available) {
        nextMessage = 'Sold out' + size + color;
        nextState = 'sold-out';
      } else if (variant.tracked && !variant.continue_selling && variant.quantity > 0 && variant.quantity <= threshold) {
        nextMessage = 'Only ' + variant.quantity + ' left' + size + color;
        nextState = 'low';
      } else {
        nextMessage = 'Available' + size + color;
        nextState = 'available';
      }
      if (message.textContent !== nextMessage) message.textContent = nextMessage;
      box.dataset.stockState = nextState;
      box.hidden = false;
    };
    box._fashionStockRefresh = render;
    render();
  };
  const scan = () => document.querySelectorAll('[data-fashion-stock]').forEach((box) => {
    if (box.dataset.initialized === 'true') box._fashionStockRefresh?.();
    else init(box);
  });
  document.addEventListener('change', (event) => {
    if (!event.target.matches('input[type="radio"], select') || !event.target.closest('variant-selects, variant-radios')) return;
    requestAnimationFrame(() => requestAnimationFrame(scan));
  });
  const observePickerReplacement = () => {
    if (!document.body) return;
    const observer = new MutationObserver((records) => {
      const pickerChanged = records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1 && (
        node.matches?.('product-info, variant-selects, variant-radios, [data-fashion-stock]')
        || node.querySelector?.('product-info, variant-selects, variant-radios, [data-fashion-stock]')
      )));
      if (pickerChanged) requestAnimationFrame(scan);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };
  const start = () => { scan(); observePickerReplacement(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
